__turbopack_context__.v({
  "active": "style-module-scss-module__1EG9IG__active",
  "avatarWrapper": "style-module-scss-module__1EG9IG__avatarWrapper",
  "backgrounds": "style-module-scss-module__1EG9IG__backgrounds",
  "bgItem": "style-module-scss-module__1EG9IG__bgItem",
  "companyLogo": "style-module-scss-module__1EG9IG__companyLogo",
  "content": "style-module-scss-module__1EG9IG__content",
  "description": "style-module-scss-module__1EG9IG__description",
  "industry": "style-module-scss-module__1EG9IG__industry",
  "list": "style-module-scss-module__1EG9IG__list",
  "listItem": "style-module-scss-module__1EG9IG__listItem",
  "mainTitle": "style-module-scss-module__1EG9IG__mainTitle",
  "progressSvg": "style-module-scss-module__1EG9IG__progressSvg",
  "quoteMark": "style-module-scss-module__1EG9IG__quoteMark",
  "section": "style-module-scss-module__1EG9IG__section",
  "slideAvatar": "style-module-scss-module__1EG9IG__slideAvatar",
  "slideInfo": "style-module-scss-module__1EG9IG__slideInfo",
  "slideName": "style-module-scss-module__1EG9IG__slideName",
  "slidePosition": "style-module-scss-module__1EG9IG__slidePosition",
  "slideTitle": "style-module-scss-module__1EG9IG__slideTitle",
  "switcherButton": "style-module-scss-module__1EG9IG__switcherButton",
});
